import axios from "axios"
import { getBaseURLforBackEnd , getConfigAxios , } from '@/utils.js'


export default {
    methods:{
        doReportFile (IDLABSelected,clientIP,pure_img ,col_if_pure_img , arr_img_data_want){

            const datTo =    {  "ln": IDLABSelected.idlab,
                                "ip": clientIP,
                                "kind": IDLABSelected.kind.toLowerCase(),
                                "img" : {"pure": pure_img,"col": col_if_pure_img ,"data_want" :arr_img_data_want}

                            }
            // console.log(JSON.stringify(datTo))
            return new Promise((resolve,reject) => {
               // axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/convhtmlfiletopdf_v2`, datTo, getConfigAxios())
                    .then((res) => {
                        // console.log(JSON.stringify(res.data))
                        resolve(res.data)
                    })
                    .catch(err=>{
                        reject(err)
                    })
            })


        }
    },
    data(){
        return {
            loadingReportFile : false,
            loadingImgReportFile : false,
        }
    }



}